<template>
  <div>
    <div class="donations">
      <div class="centered-content">
        <DataRows
          :mainColor="donorStore.mainColor"
          :store="donorStore"
          :items="donorStore.donations || []"
          :onBrowse="redirectToCMS"
          :onExport="exportDonations"
          :showProfileName="true"
          :showEmployeeDetails="false"
          :searchFields="['organization.organizationName']"
          :menuItems="menuItems"
          noDonationsTitle="You haven't made any donations yet."
          noDonationsMessage="Find the causes that matter most to you on our organization search page!"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { useDonorStore } from '@/stores/DonorStore.js';
import { useSnackbarStore } from '@/stores/SnackbarStore.js';
import DataRows from '@/components/data/DataRows.vue';
import { exportDonations as exportDonationsHelper } from '@/helpers/exportHelper.js';

const donorStore = useDonorStore();

const redirectToCMS = () => {
  window.location.href = donorStore.domain.replace(/\/$/, '') + '/organizations';
};

async function exportDonations() {
  const result = await exportDonationsHelper(donorStore);
  if (result === false) {
    useSnackbarStore().show('Failed to export donations.', 'error');
  }
}

const menuItems = [
  {
    text: 'Resend Receipt',
    emit: 'resendReceipt',
    disabled: false,
    disabled_text: null,
    type: 'default',
  },
];
</script>
<style lang="scss" scoped>
.blank-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.button {
  margin: 0 auto 20px;
}

.list-donation {
  max-width: 930px;
}
.totals {
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  flex-wrap: wrap;
}
.disabled-img {
  opacity: 0.5;
}
.donation-tile {
  height: 96px;
  width: 100%;
  background-color: white;
  margin: 20px 0;
  align-items: center;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 16px 0;
  position: relative;
}
.data-holder-small {
  width: 150px;
}
.data-holder-medium {
  display: flex;
  width: 150px;
}
.data-holder-large {
  width: 300px;
  overflow: hidden;
}
.reverse-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.action-button {
  position: absolute;
  top: 0;
  right: -90px;
  width: 140px;
}
.pageNumber {
  padding: 10px;
}
.index {
  text-align: center;
  width: 20px;
  margin: 0 20px;
  line-height: 1.8rem;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}
a {
  text-decoration: none;
}

.pagination .pageNumber {
  margin: 0 5px;
  padding: 0 8px;
  border-radius: 3px;
  cursor: pointer;
}
.pagination .pageNumber:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.filters-sidebar {
  position: absolute;
  top: 0;
  right: 0;
  background-color: white;
  width: 250px;
  height: 100%;
  z-index: 1;
}
.options-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.filter {
  margin: 0 10px;
  z-index: 1;
}
.search-filters {
  align-items: center;
}
@media screen and (max-width: 1024px) {
  .options-bar {
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .donation-tile {
    padding: 16px;
  }
}
@media screen and (max-width: 1600px) {
  .data-holder-small {
    width: 130px;
  }
  .data-holder-medium {
    width: 150px;
  }
  .data-holder-large {
    width: 250px;
  }
  .list-donation {
    padding-bottom: 80px;
  }
}
@media screen and (max-width: 800px) {
  .data-holder-small {
    width: 100px;
  }
  .data-holder-medium {
    width: 130px;
  }
  .data-holder-large {
    width: 200px;
  }
  .list-donation {
    padding-bottom: 80px;
  }
}
@media (max-width: 768px) {
  /* Hide filters on tablet and lower sizes */
  .search-filters {
    flex-direction: column;
    padding: 5px 0 0 0;
  }
  .list-donation {
    padding-bottom: 80px;
  }
}
@media screen and (max-width: 624px) {
  .donation-tile {
    flex-direction: column;
    height: 168px;
  }
  .action-button {
    top: 0px;
    right: -100px;
  }
  .data-holder-medium {
    width: 100%;
  }
  .data-holder-large {
    width: 100%;
  }
  .reverse-mobile {
    width: 100%;
    align-items: flex-start;
  }
  .search-filters {
    width: 230px;
  }
  .list-donation {
    padding-bottom: 80px;
  }
}
@media (max-width: 420px) {
  .search-filters {
    width: 175px;
  }
  .list-donation {
    padding-bottom: 80px;
  }
  .options-bar {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 !important;
  }
}
</style>
